import * as React from 'react';

import {Link} from 'shells/link/link';
import {Modal} from 'shells/modal/modal';
import {ModalHeader} from 'shells/typography/modal-header';

import {RegenerateRecoveryCodesScreen} from '../screens/regenerate-recovery-codes-screen';

import styles from './view-recovery-codes.module.css';

type Props = {
    isShowingCodes: boolean;
    setIsShowingCodes: (arg1: boolean) => void;
};

export function ViewRecoveryCodes(props: Props) {
    const [codesAreSaved, setCodesAreSaved] = React.useState(true);

    return (
        <Modal
            isOpen={props.isShowingCodes}
            closeButton={false}
            onClose={() => {
                props.setIsShowingCodes(false);
            }}
            canClickOutsideToClose={false}
            canEscapeToClose={false}
            maxHeight={600}
            noPadding={false}
        >
            <ModalHeader>View or regenerate recovery codes</ModalHeader>
            <RegenerateRecoveryCodesScreen
                method={'view'}
                onNextReady={() => {
                    setCodesAreSaved(true);
                }}
                onNextNotReady={() => {
                    setCodesAreSaved(false);
                }}
            />
            <div className={styles['done-container']}>
                <Link
                    variant='button-primary'
                    size='big'
                    onClick={() => {
                        if (codesAreSaved) {
                            props.setIsShowingCodes(false);
                        }
                    }}
                    // @ts-expect-error
                    disabled={!codesAreSaved}
                    className={styles['done-button']}
                >
                    {codesAreSaved ? 'Done' : 'I saved these codes'}
                </Link>
            </div>
        </Modal>
    );
}
